import React, { createContext, useState, useEffect } from "react";
export const ThemeContext = createContext({});

export const ThemeContextProvider = ({ children }) => {
	const [theme, setTheme] = useState("dark");
	const [openSocials, setOpenSocials] = useState(true);
	const [openDrawer, setOpenDrawer] = useState(false);

	const getTheme = () => {
		const hasTheme = localStorage.getItem("theme");

		if (!hasTheme) {
			localStorage.setItem("theme", theme);
		}

		setTheme(hasTheme);
	};

	useEffect(() => {
		getTheme();

		return () => {
			setTheme(theme);
		};
	}, []);

	const handleTheme = (themeValue) => {
		setTheme(themeValue);
		localStorage.setItem("theme", themeValue);
	};

	return (
		<ThemeContext.Provider
			value={{
				theme,
				setTheme,
				handleTheme,
				openSocials,
				setOpenSocials,
				openDrawer,
				setOpenDrawer,
			}}>
			{children}
		</ThemeContext.Provider>
	);
};
